import { PERMS } from '@/config/permissions';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const HotelList = () => import('@/modules/base/hotel/HotelList.vue');
const LinenTypeList = () => import('@/modules/base/linen-types/LinenTypeList.vue');
const SubsidyConfig = () => import('@/modules/base/subsidy/SubsidyConfig.vue');

export const baseDataRoutes = {
  path: '/base-data',
  name: 'BaseData',
  component: DefaultLayout,
  meta: {
    title: '基础数据',
    titleKey: 'route.baseData',
    icon: 'DataAnalysis',
    order: 2,
  },
  children: [
    {
      path: 'hotels',
      name: 'Hotels',
      component: HotelList,
      meta: {
        title: '酒店管理',
        titleKey: 'route.hotels',
        icon: 'home',
        order: 20,
        permissions: [PERMS.HOTEL_VIEW],
      },
    },
    {
      path: 'linen-types',
      name: 'LinenTypes',
      component: LinenTypeList,
      meta: {
        title: '布草类型库',
        titleKey: 'route.linenTypes',
        icon: 'appstore',
        order: 21,
        permissions: [PERMS.LINEN_VIEW],
      },
    },
    {
      path: 'subsidy',
      name: 'SubsidyConfig',
      component: SubsidyConfig,
      meta: {
        title: '补贴配置',
        titleKey: 'route.subsidy',
        icon: 'setting',
        order: 22,
        permissions: [PERMS.MILEAGE_SUBSIDY_VIEW, PERMS.HANDLING_SUBSIDY_VIEW],
      },
    },
  ],
};
